import { render } from "./ViewSong.vue?vue&type=template&id=58c0edb7&ts=true"
import script from "./ViewSong.vue?vue&type=script&lang=ts"
export * from "./ViewSong.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__